import "primeicons/primeicons.css"; //icons
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { TabMenu } from 'primereact/tabmenu';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { Menubar } from 'primereact/menubar';
import { SlideMenu } from 'primereact/slidemenu';
import { Button } from 'primereact/button';
import authenticationService from '../../services/authentication.service';
import Burger from '../Burger/Burger';
import Menu from '../Menu/Menu';
import "./Navbar.css";
import { Image } from './Navbar.styles';
import { Avatar } from 'primereact/avatar';
import useWindowDimensions from "../hooks/useDimensions.js";
import { Link, useHistory } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import { Toast } from 'primereact/toast';
import apis from "../../api/index.js";
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Badge } from 'primereact/badge';
import { OverlayPanel } from 'primereact/overlaypanel';
import { classNames } from 'primereact/utils';
import { ScrollPanel } from "primereact/scrollpanel";
import { Menu as PrimeMenu} from 'primereact/menu';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Navbar
Description : Barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa la barra de navegación desde cero.
2/11/2021 Cristian Andres Pizo Mina – Se agregaron Elementos de nombre de cuenta y salir.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */
function Navbar({ open, setOpen }) {

    const location = useLocation();
    const [username, setUsername] = useState(false)
    const [contract, setContract] = useState("")
    const [contractList, setContractList] = useState([])
    const [menuList, setMenuList] = useState([])
    const [notifications, setNotifications] = useState([])
    const node = useRef();
    const menu = useRef(null);
    let history = useHistory();
    const { height, width } = useWindowDimensions();
    const headers = {
        authorization: localStorage.getItem('token')
    }
    const toast = useRef(null);
    const op = useRef(null);

    // set initial state
    const [user, showText] = useState(false);

    // update state on button click
    const setText = (user) => {
        return showText(!user)
    }

    useEffect(() => {
        const template = async () => {
            let contrato = localStorage.getItem('contract_id') ? localStorage.getItem('contract_id') : ''
            try {
                await apis.getUserType(headers, contrato).then(res => {
                    console.log(res.data)
                    if (res.data.CONTRACTS) {
                        setContractList(res.data.CONTRACTS)
                        localStorage.setItem('turns', res.data.TURNS)
                        localStorage.setItem('turns_approver', res.data.TURNS_APPROVER)
                        setContract({
                            detail_id: res.data.CONTRACT_ID,
                            description: res.data.CONTRACT_DESC
                        })
                        localStorage.setItem("options_web", JSON.stringify(res.data.OPTIONS_WEB))
                        localStorage.setItem("name", res.data.NAME)
                        localStorage.setItem("hasKiosko", res.data.KIOSKO)
                        localStorage.setItem("sign_photo", res.data.SIGN_PHOTO)
                    }
                })
            }
            catch (err) {
                localStorage.removeItem('turns')
                localStorage.removeItem('turns_approver')
                localStorage.removeItem('options_web')
                console.log("Wait")
            }
        }
        template()
    }, [])

    useEffect(() => {
        getNotifications()
    }, [])

    let intervalId

    const interval = () => {
        intervalId = !intervalId && setInterval(() => {
            getNotifications()
        }, 300000)

        if (!localStorage.getItem('client')) {
            console.log("Se cierra")
            clearInterval(intervalId);
        }
    }

    useEffect(() => {
        interval()
        return () => clearInterval(intervalId)
    }, [localStorage.getItem('client')])

    // Track events outside scope
    const clickOutside = (e) => {
        if (node.current) {
            if (node.current.contains(e.target)) {
                // inside click
                return;
            }
        }
        // outside click
        showText(false)
        setOpen(false)
    }

    function logOut() {
        confirmDialog({
            message: '¿Esta seguro que desea cerrar sesión?',
            header: 'Cerrar sesión',
            icon: 'pi pi-info-circle',
            position: 'top',
            accept,
            acceptLabel: 'Si',
            rejectLabel: 'No'
        });
    }

    const accept = () => {
        authenticationService.signOut();
    }

    const refreshInfo = async (value) => {
        setContract(value)
        console.log(value)
        let contrato = value.contract_id
        let prevType = localStorage.getItem("type")
        console.log(contrato)
        try {
            await apis.getUserType(headers, contrato).then(res => {
                localStorage.setItem("type", res.data.TYPE_USER)
                localStorage.setItem("enabled", res.data.ENABLED)
                localStorage.setItem("entity", res.data.ENTITY)
                localStorage.setItem("client", res.data.CLIENT)
                localStorage.setItem("terms", res.data.TERMS)
                localStorage.setItem("number_id", res.data.NUMBER_ID)
                localStorage.setItem("contract_id", res.data.CONTRACT_ID)
                localStorage.setItem("novelties", res.data.NOVELTIES_MODULE)
                localStorage.setItem("instance", res.data.INSTANCE)
                localStorage.setItem("logo", res.data.LOGO)
                localStorage.setItem("pin", res.data.PIN)
                localStorage.setItem("name", res.data.NAME)
                localStorage.setItem("options_web", JSON.stringify(res.data.OPTIONS_WEB))
                localStorage.setItem('turns', res.data.TURNS)
                localStorage.setItem('turns_approver', res.data.TURNS_APPROVER)
                localStorage.setItem("hasKiosko", res.data.KIOSKO)
                localStorage.setItem("sign_photo", res.data.SIGN_PHOTO)
                if (prevType === 'APPROVER' && res.data.TYPE_USER === 'CLIENT') {
                    history.push("/CreatePerson")
                }
                history.go(0)
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        // history.push(location.pathname)
    }

    const getNotifications = async () => {
        let client = localStorage.getItem('client') ? localStorage.getItem('client') : ''
        let entity = localStorage.getItem('entity') ? localStorage.getItem('entity') : ''
        try {
            await apis.getNotifications(entity, client, headers).then(res => {
                let notifications_ = []
                const global = res.data["GLOBAL_NOTIFICATION"] ? res.data["GLOBAL_NOTIFICATION"] : []
                const user = res.data["USER_NOTIFICATION"] ? res.data["USER_NOTIFICATION"] : []
                if (global.length > 0) {
                    notifications_ = [...global]
                }
                if (user.length > 0) {
                    notifications_ = [...notifications_, ...user]
                }
                setNotifications([...notifications_])
                localStorage.removeItem('isAvailable')
            })
        }
        catch (err) {
            console.log("Wait")
            if (err.response?.data.code === 403) {
                localStorage.setItem('isAvailable', false)
            }
        }
    }

    const checkNotifications = async (id) => {
        const payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ID: id
        }
        try {
            await apis.checkNotification(payload, headers).then(res => {
                let notifications_ = []
                const global = res.data["GLOBAL_NOTIFICATION"] ? res.data["GLOBAL_NOTIFICATION"] : []
                const user = res.data["USER_NOTIFICATION"] ? res.data["USER_NOTIFICATION"] : []
                if (global.length > 0) {
                    notifications_ = [...global]
                }
                if (user.length > 0) {
                    notifications_ = [...notifications_, ...user]
                }
                setNotifications([...notifications_])
                op.current.hide();
                toast.current.show({ severity: 'success', detail: "Notificación leída" });
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', detail: err.response.data.message, sticky: true });
        }
    }

    const optionTemplate = (option) => {
        console.log(option)
        return (
            <div className="flex align-items-center justify-content-start" >
                <Tooltip target='.custom-target-icon' />
                <div className="custom-target-icon" style={{ marginLeft: '-0.5rem' }}
                    data-pr-position="top"
                    data-pr-tooltip={option.description} >
                    {option.description}
                </div>
            </div >
        );
    }

    const itemTemplate = (product, index) => {
        return (
            <div className="col-12" key={product.ID}>
                <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
                    <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                        <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                            <div className="flex flex-row">
                                <i className={product.ICON}
                                    style={{ color: product.COLOR, fontSize: '1.5rem' }}></i>
                                <div className="text-sm font-bold text-900 ml-3">{product.NAME}</div>
                            </div>
                            <span className="text-sm font-semibold text-justify">{product.NOTIFICATION}</span>
                        </div>
                        {product.TYPE === "USER" && <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                            <Button icon="pi pi-check" className="p-button-rounded" severity="success" text onClick={() => checkNotifications(product.ID)}></Button>
                        </div>}
                    </div>
                </div>
            </div>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    const NotificationButton = () => {
        return(
            <div className={width > 768 && "mt-2"}>
                <Toast ref={toast} />
                <Button type="button" onClick={(e) => op.current.toggle(e)} style={{ backgroundColor: '#1061a2', border: 'none' }}>
                    <Avatar className="p-overlay-badge" icon="pi pi-bell" style={{ backgroundColor: '#1061a2', color: '#ffffff', width: '100%' }} size="normal">
                        {notifications.length > 0 && <Badge className="p-badge-danger" value={notifications.length} />}
                    </Avatar>
                    {width <= 768 && 
                        <span style={{marginLeft: '0.8rem'}}>Notificaciones</span>
                    }
                </Button>
                <OverlayPanel ref={op} style={{ width: '24rem', display: 'flex', justifyContent: 'center', marginTop: width <= 768 ? '8rem' : '2rem' }} className="scrollpanel-demo2">
                    {notifications.length > 0 ?
                        <ScrollPanel
                            className="custombar1"
                            style={{
                                // ...(open ? styleOpen : styleClose),
                                height: '11rem',
                                width: '24rem',
                                textAlign: 'left !important',
                                backgroundColor: 'white'
                                // display: 'flex',
                                // flexWrap: 'wrap'
                            }}>
                            <DataView value={notifications} listTemplate={listTemplate} />
                        </ScrollPanel>
                        :
                        <div>No hay notificaciones pendientes</div>
                    }
                </OverlayPanel>
            </div>
        )
    }

    const modelo2 = (
        [
            width <= 768 ? {
                label: "Si hay", 
                template: (item, options) => {
                    return(
                        <Button
                            style={{ backgroundColor: "#1061a2", border: 'none'  }}  
                            onClick={(event) => {
                            menu.current.toggle(event)
                            history.push("/CreatePerson");
                        }}>
                            {localStorage.getItem("logo") ?
                            <Avatar className="h-1" style={{ backgroundColor: "#1061a2", border: 'none', width: "3rem", zIndex: 1000 }} image={localStorage.getItem("logo")} />
                            :
                            <span className='pi pi-fw pi-user' style={{ marginRight: "0.5rem" }}></span>}
                        </Button>
                    )
                }
            }
            :
            {
                template: (item, options) => {
                    return(
                        <Button style={{display: 'none'}} disabled/>
                    )
                }
            }
            ,
            {
                
                template: (item, options) => {
                    return (
                        <NotificationButton/>
                    )
                }
            },
            {
                template: (item, options) => {
                    if (localStorage.getItem('logo')) {
                        return (
                            <div className="list flex flex-row align-items-center" >
                                <Tooltip target='.custom-target-icon' />
                                <Dropdown
                                    className="list"
                                    value={contract}
                                    emptyMessage={"No hay opciones disponibles"}
                                    onChange={(e) => {
                                        refreshInfo(e.value)
                                    }}
                                    optionLabel="description"
                                    // itemTemplate={optionTemplate}
                                    tooltip={contract.description}
                                    tooltipOptions={{ position: 'bottom' }}
                                    options={contractList} placeholder={contract.description}
                                    style={{
                                        backgroundColor: 'white !important',
                                        height: "60%",
                                        width: '12rem'
                                    }}
                                    disabled={localStorage.getItem('kiosco')}
                                />
                                {width > 768 &&
                                    <Link className={options.className} to="/CreatePerson">
                                        <Avatar className="h-1" style={{ width: "3rem" }} image={localStorage.getItem("logo")} />
                                    </Link>
                                }
                            </div>
                        )
                    }
                    else {
                        return (
                            <div className="list flex flex-row align-items-center" >
                                <Tooltip target='.custom-target-icon' />
                                <Dropdown
                                    className="list"
                                    value={contract}
                                    emptyMessage={"No hay opciones disponibles"}
                                    onChange={(e) => {
                                        refreshInfo(e.value)
                                    }}
                                    // itemTemplate={optionTemplate}
                                    optionLabel="description"
                                    tooltip={contract.description}
                                    tooltipOptions={{ position: 'bottom' }}
                                    options={contractList} placeholder={contract.description}
                                    style={{
                                        backgroundColor: 'white !important',
                                        height: "60%",
                                        width: '12rem'
                                    }}
                                    disabled={localStorage.getItem('kiosco')}
                                />
                                {width > 768 &&
                                    <Link className={options.className} to="/CreatePerson">
                                        <span className='pi pi-fw pi-user' style={{ marginRight: "0.5rem" }}></span>
                                        <span className={options.labelClassName}>{item.label}</span>
                                    </Link>
                                }
                            </div>
                        )
                    }
                }, command: () => {
                    history.push("/CreatePerson");
                }
            },
            { label: 'SALIR', icon: 'pi pi-fw pi-power-off', command: () => { logOut() } }
        ]
    )

    const modelo3 = (
        [
            {   
                template: (item, options) => {
                    return (
                        <NotificationButton/>
                    )
                }
            },
            {
                template: (item, options) => {
                    return (
                        <div className="list flex flex-row align-items-center" >
                            <Tooltip target='.custom-target-icon' />
                            <Dropdown
                                className="list"
                                value={contract}
                                emptyMessage={"No hay opciones disponibles"}
                                onChange={(e) => {
                                    refreshInfo(e.value)
                                }}
                                // itemTemplate={optionTemplate}
                                optionLabel="description"
                                tooltip={contract.description}
                                tooltipOptions={{ position: 'bottom' }}
                                options={contractList} placeholder={contract.description}
                                style={{
                                    backgroundColor: 'white !important',
                                    marginTop: '2px',
                                    width: '12rem'
                                }}
                                disabled={localStorage.getItem('kiosco')}
                            />
                        </div>
                    )
                }
            },
            {
                label: 'Si hay',
                icon: localStorage.getItem("user") && "pi pi-fw pi-user",
                command: () => {
                    history.push("/CreatePerson");
                }
            },
            {
                label: 'SALIR', icon: 'pi pi-fw pi-power-off',
                command: () => {
                    if (localStorage.getItem("user")) {
                        logOut()
                    }
                    else {
                        window.location.href = "/"
                    }
                }
            }
        ]
    )

    const end = <>
        {width > 768 &&
            <Link to={localStorage.getItem("kiosco") ? "/Kiosko" : "/CreatePerson"}>
                {localStorage.getItem('logo') ?
                    <Avatar className="h-1" style={{ width: "3rem" }} image={localStorage.getItem("logo")} />
                    :
                    width > 768 && <span className='pi pi-fw pi-user' style={{ marginRight: "0.5rem" }}></span>}
            </Link>
        }
        {localStorage.getItem("user")
            ?
            <>
                <PrimeMenu ref={menu} model={!localStorage.getItem("logo") ? modelo3 : modelo2}
                    popup viewportHeight={120} menuWidth={100} className=""
                    style={{
                        backgroundColor: "#1061a2", color: "white", right: "0px", marginTop: '0.2rem', width: '16rem'
                    }}
                />
                <Button type="button" icon="pi pi-user" style={{ backgroundColor: "#1061a2", border: 'none' }} onClick={(event) => menu.current.toggle(event)} />
            </>
            :
            <Button type="button" icon="pi pi-power-off" style={{ backgroundColor: "#1061a2", border: 'none' }} onClick={() => { window.location.href = "/" }} />
        }
    </>

    return (
        <div style={location.pathname.match(/Login/) || location.pathname.match(/Register/) ||
            location.pathname.match(/CompleteRegister/) || location.pathname.match(/APIDocumentation/) ? { display: "none" } : console.log("Si")}
            className="bar">
            <Toast ref={toast} />
            {localStorage.getItem("enabled") && localStorage.getItem('user') &&
                <div>
                    <Tooltip />
                    {width > 768
                        ?
                        <TabMenu model={!localStorage.getItem("logo") ? modelo3 : modelo2} activeIndex={1}/>
                        :
                        <Menubar style={{
                            backgroundColor: "#1061a2", height: "3.7rem", border: 'none',
                            borderRadius: 0, alignContent: 'center', justifyContent: 'center'
                        }} className="pbar" end={end} />
                    }
                </div>
            }
            <>
                <div>
                    <Link to={localStorage.getItem("kiosco") ? "/Kiosko" : "/CreatePerson"}>
                        <Image src={process.env.REACT_APP_LOGO_NAVBAR}
                            style={
                                { width: "12rem", height: "3rem", marginLeft: "4rem", zIndex: "191", marginTop: !localStorage.getItem("logo") || width <= 675 ? "0.4rem" : "0.6rem" }
                            }
                            alt="Remuner Lite"
                        />
                    </Link>
                    {!localStorage.getItem("user") && <Menubar style={{
                        backgroundColor: "#1061a2", height: "3.5rem", border: 'none',
                        borderRadius: 0, alignContent: 'center', justifyContent: 'center'
                    }} className="pbar" />}
                </div>
                {
                    localStorage.getItem("user") && <div>
                        {/* // ref={node} onClick={() => setText(user)} */}
                        {!localStorage.getItem('kiosco') && <Burger open={open} setOpen={setOpen} />}
                        {/* <Menu open={open} setOpen={setOpen} /> */}
                    </div>
                }
            </>
        </div>
    )

}

export default Navbar